import {
  CABIN_CODE,
  CHECK_IN_STATUS,
  PASSENGER_LOYALTY_TYPE,
  PASSENGER_TICKET_TYPE,
  PASSENGER_TYPE_CATEGORY,
  PRODUCT_CODE,
  RESERVATION_TYPE,
  SEAT_ASSIGN_STATUS,
  TravelReservation
} from '@com-delta-idp/mnx-trip-management-shared-ui';
import { AncillariesMock } from './travel-reservation-ancillaries.mocks';
import { PASSENDER_TRIP } from './travel-reservation-passenger-trips.mocks';
import { TRAVEL_RESERVATION_TRIPS } from './travel-reservation-trips.mocks';

export const TRAVELRESERVATION: TravelReservation = {
  travelReservationRequest: {
    using: 'CONFIRMATION',
    confirmationNum: 'G5ISSC',
    givenNames: 'JOHN',
    surname: 'STEELE'
  },
  travelReservations: [
    {
      reservationResourceId: 'dcb729ca-cd50-488b-8658-936fdb1ce8d4',
      reservation: {
        emailRefused: false,
        emailProvided: false,
        bookingReferences: [
          {
            id: 'G5ISSC',
            organization: {
              id: 'DL'
            }
          },
          {
            id: '12345',
            organization: {
              id: 'DLV'
            }
          }
        ],
        nonrefundable: true,
        type: RESERVATION_TYPE.REVENUE,
        bookingCreationDt: '2022-05-18',
        ticketExpirationDt: '2023-12-31',
        corporateBooking: false,
        ticketed: true,
        skyPriority: true,
        tripType: 'ROUND_TRIP',
        cartId: 'string',
        vendorId: 'string',
        checkinEligible: true,
        standbyEligible: true,
        companionBooking: true,
        holdExpirationUtcDateTime: '2024-05-08T16:08:07Z',
        agency: 'AAA Travel agency',
        lifeStyleCode: 'CORE',
        packageType: 'MCO,MCO',
        vacationDestinationStation: { code: 'ATL', name: 'Atlanta' },
        vacationOriginStation: { code: 'JAX', name: 'Jacksonville Intl' },
        ancillaries: [AncillariesMock],
        isViewOnly: true,
        paymentStatus: 'scheduled_pay',
        landDestCode: 'MUC,MUC'
      },
      passengers: [
        {
          passengerResourceId: '2d8z22z4-b59d-3ca6-zeb0-cc9z40586zz9',
          givenNames: 'JOHN',
          surname: 'STEELE JR',
          firstNameNum: '01',
          lastNameNum: '01',
          customerId: '0002222451110',
          passengerType: {
            id: 'A',
            code: 'ADT',
            name: 'ADULT',
            category: PASSENGER_TYPE_CATEGORY.ADULT
          },
          tickets: [
            {
              number: '0062317806856',
              posCityCode: 'LAS',
              deliveryType: PASSENGER_TICKET_TYPE.ETICKET
            }
          ],
          loyaltyProgramAccounts: [
            {
              loyaltyProgram: {
                name: 'SkyMiles',
                owner: [
                  {
                    code: 'DL',
                    name: 'Delta Air Lines'
                  }
                ]
              },
              number: '2222451110',
              tierLevelCode: PASSENGER_LOYALTY_TYPE.SILV,
              tierLevelName: 'Silver Medallion',
              tierFullLevelName: 'Silver Medallion',
              tierLevelPriority: 'Elite Plus',
              threeSixtyMember: true
            }
          ],
          infant: {
            passengerResourceId: '2d8z22z4-b59d-3ca6-zeb0-cc9z40586zz9',
            givenNames: 'JOHN',
            surname: 'STEELE JR',
            firstNameNum: '01',
            lastNameNum: '01',
            customerId: '0002222451110',
            passengerType: {
              id: 'B',
              code: 'IF',
              name: 'INFANT WITHOUT A SEAT',
              category: PASSENGER_TYPE_CATEGORY.INFANT_IN_ARMS
            },
            tickets: [
              {
                number: '0062317806856',
                deliveryType: PASSENGER_TICKET_TYPE.ETICKET
              }
            ],
            loyaltyProgramAccounts: [
              {
                loyaltyProgram: {
                  name: 'SkyMiles',
                  owner: [
                    {
                      code: 'DL',
                      name: 'Delta Air Lines'
                    }
                  ]
                },
                number: '2222451110',
                tierLevelCode: PASSENGER_LOYALTY_TYPE.SILV,
                tierLevelName: 'Silver Medallion',
                tierFullLevelName: 'Silver Medallion',
                tierLevelPriority: 'Elite Plus',
                threeSixtyMember: true
              }
            ],
            passengerTrips: [
              PASSENDER_TRIP,
              {
                tripId: 2,
                checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
                passengerSegments: [
                  {
                    segmentId: 3,
                    bookedCabinClass: {
                      code: CABIN_CODE.Y,
                      name: 'Main Cabin',
                      productCode: PRODUCT_CODE.MAIN
                    },
                    checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
                    passengerLegs: [
                      {
                        legId: 1,
                        seatAssignments: [
                          {
                            seat: {
                              actualCabinClass: [
                                {
                                  code: CABIN_CODE.Y,
                                  name: 'Main Cabin',
                                  productCode: PRODUCT_CODE.MAIN
                                }
                              ],
                              column: 'G',
                              number: '18G',
                              seatRow: {
                                number: 18
                              }
                            },
                            seatAssignmentType: SEAT_ASSIGN_STATUS.RESERVED
                          }
                        ],
                        redEye: false
                      }
                    ]
                  },
                  {
                    segmentId: 4,
                    bookedCabinClass: {
                      code: CABIN_CODE.Y,
                      name: 'Main Cabin',
                      productCode: PRODUCT_CODE.MAIN
                    },
                    checkinStatus: CHECK_IN_STATUS.STANDBY,
                    passengerLegs: [
                      {
                        legId: 1,
                        seatAssignments: [
                          {
                            seat: {
                              actualCabinClass: [
                                {
                                  code: CABIN_CODE.Y,
                                  name: 'Main Cabin',
                                  productCode: PRODUCT_CODE.MAIN
                                }
                              ],
                              column: 'D',
                              number: '16D',
                              seatRow: {
                                number: 16
                              }
                            },
                            seatAssignmentType: SEAT_ASSIGN_STATUS.ASSIGNED
                          }
                        ],
                        redEye: false
                      }
                    ]
                  }
                ]
              }
            ]
          },
          passengerTrips: [
            PASSENDER_TRIP,
            {
              tripId: 2,
              checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
              passengerSegments: [
                {
                  segmentId: 3,
                  bookedCabinClass: {
                    code: CABIN_CODE.Y,
                    name: 'Main Cabin',
                    productCode: PRODUCT_CODE.MAIN
                  },
                  checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
                  passengerLegs: [
                    {
                      legId: 1,
                      seatAssignments: [
                        {
                          seat: {
                            actualCabinClass: [
                              {
                                code: CABIN_CODE.Y,
                                name: 'Main Cabin',
                                productCode: PRODUCT_CODE.MAIN
                              }
                            ],
                            column: 'G',
                            number: '18G',
                            seatRow: {
                              number: 18
                            }
                          },
                          seatAssignmentType: SEAT_ASSIGN_STATUS.RESERVED
                        }
                      ],
                      redEye: false
                    }
                  ]
                },
                {
                  segmentId: 4,
                  bookedCabinClass: {
                    code: CABIN_CODE.Y,
                    name: 'Main Cabin',
                    productCode: PRODUCT_CODE.MAIN
                  },
                  checkinStatus: CHECK_IN_STATUS.STANDBY,
                  passengerLegs: [
                    {
                      legId: 1,
                      seatAssignments: [
                        {
                          seat: {
                            actualCabinClass: [
                              {
                                code: CABIN_CODE.Y,
                                name: 'Main Cabin',
                                productCode: PRODUCT_CODE.MAIN
                              }
                            ],
                            column: 'D',
                            number: '16D',
                            seatRow: {
                              number: 16
                            }
                          },
                          seatAssignmentType: SEAT_ASSIGN_STATUS.ASSIGNED
                        }
                      ],
                      redEye: false
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      trips: TRAVEL_RESERVATION_TRIPS
    }
  ]
};

// export const DASH_BRD_DATA: AccountResponse = {
//   firstName: 'One',
//   lastName: 'Test',
//   primaryEmailAddress: 'onetest@noreplytestmaill.com',
//   loggedIn: false,
//   smNumber: '12345678',
//   smBalance: '141974000',
//   enrollmentDate: '2019-06-01',
//   membershipLevel: 'FO',
//   language: 'en',
//   country: 'GB'
// };

export const TRAVEL_RESERVATION_VACATIONS: TravelReservation = {
  travelReservationRequest: {
    using: 'CONFIRMATION',
    confirmationNum: '17743518',
    surname: 'ASDFGH',
    givenNames: 'ONE'
  },
  travelReservations: [
    {
      reservationResourceId: '0302534b-a561-4040-9113-58d594d86435',
      reservation: {
        bookingReferences: [
          {
            id: '17743518',
            organization: {
              id: 'DLV'
            }
          }
        ],
        type: RESERVATION_TYPE.DELTA_VACATIONS,
        status: 'courtesy_hold',
        holdExpirationUtcDateTime: '2024-06-28T14:49:00',
        packageType: 'hotel_ground_trans',
        lifeStyleCode: 'CORE',
        landDestCode: 'MCO,MCO',
        vacationDestinationStation: {
          code: '',
          name: 'Paris'
        },
        ancillaries: [AncillariesMock]
      },
      passengers: [
        {
          passengerResourceId: '9cbc6bd8-06d5-4750-9af0-f272e6135c92',
          title: 'MR',
          givenNames: 'ONE',
          surname: 'ASDFGH',
          gender: 'male'
        },
        {
          passengerResourceId: '476c03c4-db16-42d3-bd42-b21ed4455e05',
          title: 'MISS',
          givenNames: 'Dasdad',
          surname: 'Dsdsd',
          gender: 'female'
        }
      ],
      trips: []
    }
  ]
};

export const TRAVEL_RESERVATION_VACATIONS_AIR: TravelReservation = {
  travelReservationRequest: {
    using: 'CONFIRMATION',
    confirmationNum: '17743518',
    surname: 'ASDFGH',
    givenNames: 'ONE'
  },
  travelReservations: [
    {
      reservationResourceId: '0302534b-a561-4040-9113-58d594d86435',
      reservation: {
        bookingReferences: [
          {
            id: '17743518',
            organization: {
              id: 'DLV'
            }
          }
        ],
        type: RESERVATION_TYPE.DELTA_VACATIONS,
        status: 'confirmed',
        holdExpirationUtcDateTime: '2024-06-28T14:49:00',
        packageType: 'air_hotel',
        lifeStyleCode: 'CORE',
        landDestCode: 'MCO,MCO',
        vacationDestinationStation: {
          code: '',
          name: 'Paris'
        },
        ancillaries: [AncillariesMock]
      },
      passengers: [
        {
          passengerResourceId: '9cbc6bd8-06d5-4750-9af0-f272e6135c92',
          title: 'MR',
          givenNames: 'ONE',
          surname: 'ASDFGH',
          gender: 'male'
        },
        {
          passengerResourceId: '476c03c4-db16-42d3-bd42-b21ed4455e05',
          title: 'MISS',
          givenNames: 'Dasdad',
          surname: 'Dsdsd',
          gender: 'female'
        }
      ],
      trips: TRAVEL_RESERVATION_TRIPS
    }
  ]
};
